import {
	ModalUnStyled,
	type ModalUnstyledProps,
} from '@ixigo/iui/ModalUnstyled';
import Slide from '@ixigo/iui/Slide';
import type { TransitionProps } from '@ixigo/iui/useTransition';
import { useMediaQuery } from '@ixigo/iui/utils';
import cn from '../../utils/cn';

export interface ResponsiveModalProps
	extends Omit<ModalUnstyledProps, 'children'> {
	/**
	 * by default the modal slides in from the bottom for mobile and right for desktop
	 */
	transitionDirection?: 'up' | 'right';

	/**
	 * if true, the modal will be full screen. set it to false to open like bottomsheet with background content peeking through
	 */
	fullScreen?: boolean;

	classes?: {
		root?: string;
		container?: string;
	};
	TransitionProps?: TransitionProps;
	header?: React.ReactNode;
	children: React.ReactNode;
}

export function ResponsiveModal(props: Readonly<ResponsiveModalProps>) {
	const isMobile = !useMediaQuery('min-width-lg');
	const {
		open,
		onClose,
		children,
		className,
		classes = {},
		transitionDirection = isMobile ? 'up' : 'right',
		TransitionProps,
		fullScreen,
	} = props;
	const contentClass = cn(
		'shadow-100 w-full outline-none lg:w-[440px] lg:max-h-none lg:ml-auto relative self-end bg-primary',
		classes.container,
		isMobile && !fullScreen
			? 'rounded-t-30 w-full flex flex-col self-end max-h-full'
			: 'h-full',
	);

	return (
		<ModalUnStyled
			open={open}
			onClose={onClose}
			className={cn('flex', className, classes.root)}
		>
			<Slide
				in={open}
				direction={transitionDirection}
				appear
				{...TransitionProps}
			>
				<div className={contentClass} role="dialog">
					{children}
				</div>
			</Slide>
		</ModalUnStyled>
	);
}
